export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'ar'];

const splitPathSuffix = (value) => {
  const match = String(value || '/').match(/^([^?#]*)(.*)$/);
  return { pathname: match?.[1] || '/', suffix: match?.[2] || '' };
};

export const getLanguageFromPath = (pathname = '/') =>
  pathname === '/ar' || pathname.startsWith('/ar/') ? 'ar' : DEFAULT_LANGUAGE;

export const stripLanguagePrefix = (pathname = '/') => {
  const { pathname: path, suffix } = splitPathSuffix(pathname);
  const stripped = path === '/ar' ? '/' : path.replace(/^\/ar(?=\/)/, '');
  return `${stripped || '/'}${suffix}`;
};

export const localizePath = (path = '/', language = DEFAULT_LANGUAGE) => {
  if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path)) {
    return path;
  }

  const { pathname, suffix } = splitPathSuffix(path);
  const basePath = stripLanguagePrefix(pathname);

  if (language === 'ar') {
    return `${basePath === '/' ? '/ar' : `/ar${basePath}`}${suffix}`;
  }

  return `${basePath}${suffix}`;
};

export const getLanguageUrls = (pathname = '/') => ({
  en: localizePath(pathname, 'en'),
  ar: localizePath(pathname, 'ar'),
  default: localizePath(pathname, DEFAULT_LANGUAGE),
});
